import React from 'react'
import { Bar } from 'react-chartjs-2'

export default function BarChart({ data, options = {}, horizontal = false, ...props }) {
  const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: horizontal ? 'y' : 'x',
    plugins: {
      legend: {
        display: false
      }
    },
    scales: {
      x: {
        grid: {
          display: !horizontal
        }
      },
      y: {
        grid: {
          display: horizontal
        },
        beginAtZero: true
      }
    }
  }

  const mergedOptions = {
    ...defaultOptions,
    ...options,
    plugins: {
      ...defaultOptions.plugins,
      ...options.plugins
    },
    scales: {
      x: { ...defaultOptions.scales.x, ...options.scales?.x },
      y: { ...defaultOptions.scales.y, ...options.scales?.y }
    }
  }

  return <Bar data={data} options={mergedOptions} {...props} />
}
